<micro-select-combo #sel
              placeholder="Sms Status"
              [mode]="mode"
              [(id)]="smsState"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
